import { CellContext } from '@tanstack/react-table'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { DotsThree, PencilSimple, Trash } from '@phosphor-icons/react'
import * as React from 'react'
import { UserPersonalSkillsTableRow } from '../data'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { useTable } from '../context/table'

export const ActionsCell = (
  data: CellContext<UserPersonalSkillsTableRow, unknown>
) => {
  const row = data.row.original
  const { onViewSkill, onDeleteSkill } = useTable()

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button className="p-1 rounded hover:bg-gray-100">
          <DotsThree className="h-5 w-5 text-gray-500" weight="bold" />
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          className="bg-white rounded-md shadow-lg border border-gray-200 p-1 min-w-[140px]"
          align="end"
        >
          <DropdownMenu.Item
            className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded cursor-pointer outline-none"
            onSelect={() => {
              onViewSkill(row.id)
            }}
          >
            View and edit
          </DropdownMenu.Item>
          <DropdownMenu.Item
            className="flex items-center gap-2 px-3 py-2 text-sm text-red-600 hover:bg-gray-100 rounded cursor-pointer outline-none"
            onSelect={() => {
              onDeleteSkill(row.id)
            }}
          >
            Delete
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  )
}
